import { useEncounterLockStore } from '@zustore/encounterLockStore'
import { showToast } from './toast'

const WRITE_MODAL_EXTRAS = new Set([
  'QUERY_MED',
  'DESPENSE_AS_PRESCRIBE',
  'PREPARE_DOSE',
  'COMPOUND_DOSE',
  'VERIFY_MEDICATION',
  'ALLERGY_WARNING',
  'CONSENT_FORM',
  'PROCEDURE_APPROVAL',
  'INTAKE_APROVAL'
])

/** True when the active doctor encounter is completed and must not accept create/update. */
export const isEncounterWriteLocked = () => useEncounterLockStore.getState().isEncounterReadOnly

/** Returns false (and toasts) when create/update should be blocked. */
export const guardEncounterWrite = (message?: string) => {
  if (!isEncounterWriteLocked()) return true
  showToast(message ?? 'This encounter is completed. Reopen it to create or update records.')
  return false
}

/** Zustand/modal-store modal ids that create, update, cancel, or delete. */
export const isEncounterWriteModal = (modal: string) => {
  if (/^(ADD_|EDIT_|REMOVE_|DELETE_|CANCEL_|UPDATE_)/.test(modal)) return true
  return WRITE_MODAL_EXTRAS.has(modal)
}

/** Redux ModalSlicer action types that open create/update/delete flows. */
export const isEncounterWriteReduxAction = (type: string) => /^modal\/show(Add|Edit|Delete|Cancel)/.test(type)
